import { Container, IconButton, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { TestResult } from "../../../../store";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { GetResultDocuments } from "../../../../api";
import { useEffect, useState } from "react";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle test results documents

export default function ResultDocument(props: any) {
    const navigate = useNavigate();
    const { state } = useLocation();
    const testresult = state as TestResult
    const [images, setImages] = useState<[]>();

    async function GetResultDocs() {
        if (testresult.DocumentID != 0 || testresult.DocumentID != null) {
            const data = await GetResultDocuments(testresult.EMRID);
            if (data != undefined) {
                var file = new Blob([data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }
            //setImages(data);
        }
    }

    useEffect(() => {
        GetResultDocs()
    }, []);

    return (
        <Container maxWidth="lg" style={{ padding: 20 }}>
            <ListItem>
                <ListItemIcon>
                    <IconButton onClick={() => navigate('/user/home/TestResults')}>
                        <ArrowBack />
                    </IconButton>
                </ListItemIcon>
                <ListItemText>
                    <Typography variant="h5">
                        <b>Test results</b>
                    </Typography>
                </ListItemText>
            </ListItem>
            <Container style={{ maxHeight: 500, overflow: "auto", boxShadow: "lightgrey 0px 3px 5px 2px" }}>
                {images?.map((image) => {
                    return (
                        <img src={"data:image/jpeg;base64," + image} />
                    )
                })}
            </Container>
        </Container>
    );
}